const supabase_url='https://nenwyzgvqwiuvtnkbubm.supabase.co'
const supabase_anon_key='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTYyOTU0NDk3OSwiZXhwIjoxOTQ1MTIwOTc5fQ.RT0Af5IE-Ftcag4t33ZqYBL-MNq0Ha5nPsAVZELSBYQ'

export {supabase_url, supabase_anon_key};